import axios from 'axios';
import {
    Message,
} from 'element-ui'
import qs from 'qs'; //参数序列化，把数据格式转为 x-www-form-urlencoded
import router from '../src/router/index'
import store from '../src/vuex/store'

axios.create({
    crossDomain: true,
    withCredentials: true,
    time: 20000,
    headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest'
    }
})
//  request请求拦截器
axios.interceptors.request.use(config => {
    let result = store.state.globalSessionid.result;
    let loginType = store.state.loginType;

    // console.log(router)
    // console.log(loginType)
    // 登录云服务
    if (loginType == 1) {
        // console.log(result)
        // 判断是否是登录接口
        if (config.url.indexOf('companyLogin') == -1) {
            // 是否有10000登录账号  没有跳转登录页面
            if (result == undefined) {
                router.replace({ //跳转到登录页面
                    path: '/'
                });
            }
        } else {
            // console.log(result)
        }
    }
    // 登录云称重
    else {

    }


    // if (config.method === 'post') {
    //     config.data = qs.stringify(config.data);
    // } else
    if (config.method === 'get') {
        config.params = config.params || {};
        config.params.t = Date.parse(new Date()) / 1000; //添加时间戳
    }
    return config;
}, error => {
    return Promise.reject(error);
})

// response响应拦截器
axios.interceptors.response.use(response => {
    return response;
}, error => {
    let {
        response
    } = error;
    if (response) {
        var errormsg = '';
        switch (response.status) {
            case 400:
                errormsg = '错误请求'
                break;
            case 403:
                errormsg = '决绝访问'
                break;
            case 404:
                errormsg = '请求错误，未找到该资源'
                break;
            case 500:
                errormsg = '服务器出错'
                break;
            case 504:
                errormsg = '网络超时'
                break;
            default:
                errormsg = '连接错误'
        }
        Message({
            type: 'warning',
            message: errormsg
        });
        return false;
    } else {
        router.replace({ //跳转到登录页面
            path: '/'
        });

    }
})

export { uploadApi };
export default axios;


//////////////////
// WEBPACK FOOTER
// ./axios/index.js
// module id = null
// module chunks = 